import React, { useEffect, useState } from "react";
import { Form, Button, Image, Modal } from "react-bootstrap";
import { FormControl } from "@material-ui/core";
import { Table } from "react-bootstrap";
import { withStyles } from "@material-ui/core/styles";
import Dropdown from "react-dropdown";
import "react-dropdown/style.css";
import { toast } from "react-toastify";
import { errorToastStyle, successToastStyle } from "../../customToast";
import { getCostDistributionData } from "../../services/apiServices";
import request from "../../services/requestService";
import { getLocalstorage } from "../../helper";

const styles = theme => ({
  select: {
    fontSize: "13px",
    color: "#2F2F2F",
    fontFamily: "mpb",
    textWrap: "auto"
  },
  table: {
    border: "1px solid #ddd",
    borderRadius: 8
  },
  customModal: {
    maxWidth: "1200px !important"
    // width: "90% !important"
  }
});

const StateWiseCostModal = props => {
  const {
    show,
    onHide,
    comment,
    onCommentChange,
    onReject,
    error,
    stateWiseData,
    projectId,
    tableIndex
  } = props;
  const { classes } = props;

  const [statusFilter, setStatusFilter] = useState("Select");
  const [categoryFilter, setCategoryFilter] = useState("Select");
  const [towersPlannedFilter, setTowerPlanned] = useState("Select");
  const [towersInstallFil, setTowersInstall] = useState("Select");

  const statusOptions = ["Select", "Total Gram Panchayats", "Total Locations"];
  const categoryOptions = [
    "Select",
    "Gram Panchayats Covered",
    "Locations Covered"
  ];
  const towersPlanned = [
    "Select",
    "OFC to be Laid (Km)",
    "Towers Planned (No.)"
  ];
  const towersInstalled = ["Select", "OFC laid (Km)", "Towers Installed (No.)"];
  const statusToCategoryMap = {
    "Total Gram Panchayats": "Gram Panchayats Covered",
    "Total Locations": "Locations Covered"
  };

  const categoryToStatusMap = {
    "Gram Panchayats Covered": "Total Gram Panchayats",
    "Locations Covered": "Total Locations"
  };

  const plannedToInstalledMap = {
    "OFC to be Laid (Km)": "OFC laid (Km)",
    "Towers Planned (No.)": "Towers Installed (No.)"
  };

  const installedToPlannedMap = {
    "OFC laid (Km)": "OFC to be Laid (Km)",
    "Towers Installed (No.)": "Towers Planned (No.)"
  };

  const [headerDefaults, setHeaderDefaults] = useState({
    totalLocationsUncoveredHeader: "Select",
    totalLocationsConnectedHeader: "Select",
    totalOFCPlannedHeader: "Select",
    totalOFCInstalledHeader: "Select"
  });

  const [totalLocationsUncovered, setTotalLocationsUncovered] = useState();
  const [totalLocationsConnected, setTotalLocationsConnected] = useState();
  const [totalOFCPlanned, setTotalOFCPlanned] = useState();
  const [totalOFCInstalled, setTotalOFCInstalled] = useState();
  const [implementationAgency, setImplementationAgency] = useState();
  const [totalProjectCost, setTotalProjectCost] = useState();
  const physicalProgressPercentage = (
    totalOFCPlanned / totalOFCInstalled
  ).toFixed(2);
  // : "";
  const [errors, setErrors] = useState([]);
  const buildRow = loc => {
    const stateName =
      (loc.districtList && loc.districtList[0].stateName) ||
      loc.stateOrUT ||
      loc.state ||
      loc.name ||
      "";

    return {
      stateOrUT: stateName,
      totalLocationsUncovered:
        loc.totalLocationsUncovered !== undefined &&
        loc.totalLocationsUncovered !== null
          ? loc.totalLocationsUncovered
          : totalLocationsUncovered,
      totalLocationsConnected:
        loc.totalLocationsConnected !== undefined &&
        loc.totalLocationsConnected !== null
          ? loc.totalLocationsConnected
          : totalLocationsConnected,
      totalOFCPlanned:
        loc.totalOFCPlanned !== undefined && loc.totalOFCPlanned !== null
          ? loc.totalOFCPlanned
          : totalOFCPlanned,
      totalOFCInstalled:
        loc.totalOFCInstalled !== undefined && loc.totalOFCInstalled !== null
          ? loc.totalOFCInstalled
          : totalOFCInstalled,
      totalProjectCost:
        loc.totalProjectCost !== undefined && loc.totalProjectCost !== null
          ? loc.totalProjectCost
          : totalProjectCost,
      implementationAgency: loc.implementationAgency || "",
      physicalProgressPercentage:
        loc.physicalProgressPercentage !== undefined &&
        loc.physicalProgressPercentage !== null
          ? loc.physicalProgressPercentage
          : physicalProgressPercentage,

      totalLocationsUncoveredHeader:
        loc.totalLocationsUncoveredHeader || "Select",
      totalLocationsConnectedHeader:
        loc.totalLocationsConnectedHeader || "Select",
      totalOFCPlannedHeader: loc.totalOFCPlannedHeader || "Select",
      totalOFCInstalledHeader: loc.totalOFCInstalledHeader || "Select",
      tableIndex: tableIndex,
      active: true
    };
  };

  const [tableData, setTableData] = useState(() => {
    if (Array.isArray(stateWiseData) && stateWiseData.length > 0) {
      return stateWiseData.map(buildRow);
    }

    if (
      Array.isArray(props.costDistributionData) &&
      props.costDistributionData.length > 0
    ) {
      return props.costDistributionData.map(buildRow);
    }

    if (Array.isArray(props.locations) && props.locations.length > 0) {
      return props.locations.map(buildRow);
    }

    return [];
  });

  useEffect(() => {
    // if (window.location.pathname == "/create-project" && projectId) {
    //   const getCostData = request(
    //     getCostDistributionData({ projectId: projectId, active: true })
    //   );
    //   getCostData.then(resp => {
    //     if (
    //       resp &&
    //       resp.data &&
    //       Array.isArray(resp.data.data) &&
    //       resp.data.data.length
    //     ) {
    //       setTableData(resp.data.data);
    //     }
    //   });
    // }
  }, [projectId]);

  const validateTableData = data => {
    if (!Array.isArray(data) || data.length === 0) {
      return { hasError: true, type: "MANDATORY" };
    }

    let tempErrors = {};
    let hasInvalidValue = false;
    let hasMandatoryError = false;

    data.forEach((row, index) => {
      const planned = row.totalOFCPlanned;
      const installed = row.totalOFCInstalled;
      const totalGram = row.totalLocationsUncovered;
      const connectedGram = row.totalLocationsConnected;
      const totalCost = row.totalProjectCost;

      const hasPlanned =
        planned !== "" && planned != null && !Number.isNaN(Number(planned));
      const hasInstalled =
        installed !== "" &&
        installed != null &&
        !Number.isNaN(Number(installed));
      const hasTotalCost =
        totalCost !== "" &&
        totalCost != null &&
        !Number.isNaN(Number(totalCost));

      const exceeds =
        hasPlanned && hasInstalled && Number(installed) > Number(planned);

      if (exceeds) hasInvalidValue = true;

      const hastotalGram =
        totalGram !== "" &&
        totalGram != null &&
        !Number.isNaN(Number(totalGram));
      const hasconnectedGram =
        connectedGram !== "" &&
        connectedGram != null &&
        !Number.isNaN(Number(connectedGram));

      const exceedsGram =
        hastotalGram &&
        hasconnectedGram &&
        Number(connectedGram) > Number(totalGram);

      if (exceedsGram) hasInvalidValue = true;

      const rowErrors = {
        totalOFCPlanned: !hasPlanned,
        totalOFCInstalled: !hasInstalled || exceeds,

        totalLocationsUncoveredHeader:
          row.totalLocationsUncoveredHeader === "Select",
        totalLocationsConnectedHeader:
          row.totalLocationsConnectedHeader === "Select",

        totalLocationsUncovered: !hastotalGram,
        totalLocationsConnected: !hasconnectedGram || exceedsGram,

        totalOFCPlannedHeader: row.totalOFCPlannedHeader === "Select",
        totalOFCInstalledHeader: row.totalOFCInstalledHeader === "Select",

        totalProjectCost: !hasTotalCost,
        implementationAgency: String(row.implementationAgency).trim() === ""
      };

      if (Object.values(rowErrors).includes(true)) {
        hasMandatoryError = true;
      }

      tempErrors[index] = rowErrors;
    });

    setErrors(tempErrors);

    if (hasInvalidValue) {
      return { hasError: true, type: "INVALID_VALUE" };
    }

    if (hasMandatoryError) {
      return { hasError: true, type: "MANDATORY" };
    }

    return { hasError: false };
  };

  const handleChange = (index, field, value) => {
    const normalizedValue = value === "" ? "" : Number(value);
    setTableData(prev => {
      const updated = [...prev];
      const intFields = ["totalLocationsUncovered", "totalLocationsConnected"];
      const floatFields = [
        "totalOFCPlanned",
        "totalOFCInstalled",
        "totalProjectCost"
      ];
      if (intFields.includes(field)) {
        if (field == "totalLocationsUncovered" && value == 0) {
          updated[index] = {
            ...updated[index],
            ["totalLocationsConnected"]: value
          };
        }
        const uncovered = Number(updated[index].totalLocationsUncovered);
        const connected = Number(value);
        if (
          field === "totalLocationsConnected" &&
          Number.isFinite(uncovered) &&
          Number.isFinite(connected) &&
          connected > uncovered
        ) {
          updated[index] = { ...updated[index], [field]: value };
          toast.error(
            <p className="toast-text-alignment">{"Invalid Value!"}</p>,
            errorToastStyle
          );
        } else
          updated[index] = {
            ...updated[index],
            [field]: normalizedValue
          };
      } else if (floatFields.includes(field)) {
        if (field == "totalOFCPlanned" && value == 0) {
          updated[index] = { ...updated[index], ["totalOFCInstalled"]: value };
        }
        const OFCPlanned = Number(updated[index].totalOFCPlanned);
        const OFCInstalled = Number(value);
        if (
          field == "totalOFCInstalled" &&
          Number.isFinite(OFCPlanned) &&
          Number.isFinite(OFCInstalled) &&
          OFCInstalled > OFCPlanned
        ) {
          updated[index] = { ...updated[index], [field]: parseInt(value) };
          toast.error(
            <p className="toast-text-alignment">{"Invalid Value!"}</p>,
            errorToastStyle
          );
        } else
          updated[index] = {
            ...updated[index],
            [field]: parseFloat(value)
          };
      } else {
        updated[index] = { ...updated[index], [field]: value };
      }
      updated[index] = {
        ...updated[index],
        ["active"]: true,
        ...prev.headerDefaults
      };

      updated[index] = {
        ...updated[index],
        totalLocationsUncoveredHeader:
          updated[index].totalLocationsUncoveredHeader || statusFilter,
        totalLocationsConnectedHeader:
          updated[index].totalLocationsConnectedHeader || categoryFilter,
        totalOFCPlannedHeader:
          updated[index].totalOFCPlannedHeader || towersPlannedFilter,
        totalOFCInstalledHeader:
          updated[index].totalOFCInstalledHeader || towersInstallFil
      };

      const planned = parseFloat(updated[index].totalOFCPlanned) || 0;
      const installed = parseFloat(updated[index].totalOFCInstalled) || 0;
      updated[index].physicalProgressPercentage = parseFloat(
        planned > 0 ? ((installed / planned) * 100).toFixed(2) : 0
      );

      return updated;
    });
    // setErrors(prev => ({
    //   ...prev,
    //   [index]: {
    //     ...prev[index],
    //     [field]: value == ""
    //   }
    // }));
    setErrors(prev => ({
      ...prev,
      [index]: {
        ...(prev[index] || {}),
        [field]: normalizedValue === "",
        ...(field === "totalLocationsUncovered" && {
          totalLocationsConnected: false
        }),
        ...(field === "totalOFCPlanned" && {
          totalOFCInstalled: false
        })
      }
    }));
  };

  const handleStateWiseData = () => {
    const result = validateTableData(tableData);

    if (result.hasError) {
      const message =
        result.type === "INVALID_VALUE"
          ? "Invalid value"
          : "All fields are mandatory";

      toast.error(
        <p className="toast-text-alignment">{message}</p>,
        errorToastStyle
      );
      return;
    } else {
      props.handleStateWiseData(tableData, tableIndex);
      if (
        !projectId ||
        (projectId &&
          !getLocalstorage("draftedProject") &&
          window.location.pathname == "/create-project")
      ) {
        toast.success(
          <p className="toast-text-alignment">
            {"Form submitted successfully "}
          </p>,
          successToastStyle
        );
      }
    }
  };

  return (
    <Modal show={show} onHide={onHide} dialogClassName={classes.customModal}>
      <Form className="iig-modal-for-reject-action">
        <div class="state-wise-body">
          <Modal.Header closeButton />
          <Modal.Body>
            <div class="state-wise-background">
              <h4 class="state-wise-heading iig-modal-heading">
                State-wise Progress
              </h4>
              <div
                style={{
                  marginTop: "32px",
                  marginLeft: "14px",
                  overflow: tableData.length <= 2 ? "visible" : ""
                }}
                className="state-wise-progress table-wrapper"
              >
                <Table className="table" cellPadding="10" cellSpacing="0">
                  <thead>
                    <tr>
                      <th rowSpan="2" className="no-border-bottom">
                        S.No.
                      </th>
                      <th rowSpan="2" className="no-border-bottom">
                        State/UT
                      </th>
                      <th rowSpan="2" className="no-border-bottom">
                        <FormControl
                          size="small"
                          fullWidth
                          style={{ position: "relative" }}
                        >
                          <Dropdown
                            classNamePrefix="react-select"
                            menuClassName={
                              tableData.length > 1
                                ? "menu-full-width"
                                : "menu-less-width"
                            }
                            options={statusOptions}
                            className={`${classes.select} no-border-dropdown 
                                      ${
                                        errors[0] &&
                                        errors[0].totalLocationsUncoveredHeader
                                          ? "my-error-field"
                                          : ""
                                      }`}
                            onChange={e => {
                              const newValue = e.value;
                              setStatusFilter(newValue);
                              const autoCategory =
                                statusToCategoryMap[newValue] || "Select";
                              setTableData(prev => {
                                const updated = prev.map(item => ({
                                  ...item,
                                  totalLocationsUncoveredHeader: newValue,
                                  totalLocationsConnectedHeader: autoCategory
                                }));
                                return updated;
                              });
                              setHeaderDefaults(prev => ({
                                ...prev,
                                totalLocationsUncoveredHeader: newValue,
                                totalLocationsConnectedHeader: autoCategory
                              }));
                              setErrors(prev => ({
                                ...prev,
                                [0]: {
                                  ...prev[0],
                                  ["totalLocationsUncoveredHeader"]:
                                    newValue == "Select",
                                  ["totalLocationsConnectedHeader"]:
                                    autoCategory == "Select"
                                }
                              }));
                            }}
                            value={
                              tableData &&
                              tableData.length > 0 &&
                              tableData[0].totalLocationsUncoveredHeader
                                ? tableData[0].totalLocationsUncoveredHeader
                                : statusFilter
                            }
                            placeholder="Select an option"
                          />
                        </FormControl>
                      </th>
                      <th className="no-border-bottom">
                        <FormControl size="small" fullWidth>
                          <Dropdown
                            menuClassName={
                              tableData.length > 1
                                ? "menu-full-width"
                                : "menu-less-width"
                            }
                            options={categoryOptions}
                            className={`${classes.select} no-border-dropdown
                            ${
                              errors[0] &&
                              errors[0].totalLocationsConnectedHeader
                                ? "my-error-field"
                                : ""
                            }`}
                            value={
                              tableData &&
                              tableData.length > 0 &&
                              tableData[0].totalLocationsConnectedHeader
                                ? tableData[0].totalLocationsConnectedHeader
                                : categoryFilter
                            }
                            label="Category"
                            onChange={e => {
                              const newValue = e.value;
                              setCategoryFilter(newValue);
                              const autoStatus =
                                categoryToStatusMap[newValue] || "Select";
                              setTableData(prev => {
                                const updated = prev.map(item => ({
                                  ...item,
                                  totalLocationsConnectedHeader: newValue,
                                  totalLocationsUncoveredHeader: autoStatus
                                }));
                                return updated;
                              });
                              setHeaderDefaults(prev => ({
                                ...prev,
                                totalLocationsConnectedHeader: newValue,
                                totalLocationsUncoveredHeader: autoStatus
                              }));
                              setErrors(prev => ({
                                ...prev,
                                [0]: {
                                  ...prev[0],
                                  ["totalLocationsUncoveredHeader"]:
                                    autoStatus == "Select",
                                  ["totalLocationsConnectedHeader"]:
                                    newValue == "Select"
                                }
                              }));
                            }}
                          />
                        </FormControl>
                      </th>
                      <th className="no-border-bottom">
                        <FormControl size="small" fullWidth>
                          <Dropdown
                            menuClassName={
                              tableData.length > 1
                                ? "menu-full-width"
                                : "menu-less-width"
                            }
                            options={towersPlanned}
                            className={`${classes.select} no-border-dropdown
                            ${
                              errors[0] && errors[0].totalOFCPlannedHeader
                                ? "my-error-field"
                                : ""
                            }`}
                            value={
                              tableData &&
                              tableData.length > 0 &&
                              tableData[0].totalOFCPlannedHeader
                                ? tableData[0].totalOFCPlannedHeader
                                : towersPlannedFilter
                            }
                            label="towers"
                            onChange={e => {
                              const newValue = e.value;
                              setTowerPlanned(newValue);
                              const towersMapped =
                                plannedToInstalledMap[newValue] || "Select";
                              setTableData(prev => {
                                const updated = prev.map(item => ({
                                  ...item,
                                  totalOFCPlannedHeader: newValue,
                                  totalOFCInstalledHeader: towersMapped
                                }));
                                return updated;
                              });
                              setHeaderDefaults(prev => ({
                                ...prev,
                                totalOFCPlannedHeader: newValue,
                                totalOFCInstalledHeader: towersMapped
                              }));
                              setErrors(prev => ({
                                ...prev,
                                [0]: {
                                  ...prev[0],
                                  ["totalOFCPlannedHeader"]:
                                    newValue == "Select",
                                  ["totalOFCInstalledHeader"]:
                                    towersMapped == "Select"
                                }
                              }));
                            }}
                          />
                        </FormControl>
                      </th>
                      <th className="no-border-bottom">
                        <FormControl size="small" fullWidth>
                          <Dropdown
                            menuClassName={
                              tableData.length > 1
                                ? "menu-full-width"
                                : "menu-less-width"
                            }
                            options={towersInstalled}
                            className={`${classes.select} no-border-dropdown
                            ${
                              errors[0] && errors[0].totalOFCInstalledHeader
                                ? "my-error-field"
                                : ""
                            }`}
                            value={
                              tableData &&
                              tableData.length > 0 &&
                              tableData[0].totalOFCInstalledHeader
                                ? tableData[0].totalOFCInstalledHeader
                                : towersInstallFil
                            }
                            label="towers"
                            onChange={e => {
                              const newValue = e.value;
                              setTowersInstall(newValue);
                              const towersInstallMap =
                                installedToPlannedMap[newValue] || "Select";
                              setTableData(prev => {
                                const updated = prev.map(item => ({
                                  ...item,
                                  totalOFCInstalledHeader: newValue,
                                  totalOFCPlannedHeader: towersInstallMap
                                }));
                                return updated;
                              });
                              setHeaderDefaults(prev => ({
                                ...prev,
                                totalOFCInstalledHeader: newValue,
                                totalOFCPlannedHeader: towersInstallMap
                              }));
                              setErrors(prev => ({
                                ...prev,
                                [0]: {
                                  ...prev[0],
                                  ["totalOFCPlannedHeader"]:
                                    towersInstallMap == "Select",
                                  ["totalOFCInstalledHeader"]:
                                    newValue == "Select"
                                }
                              }));
                            }}
                          />
                        </FormControl>
                      </th>
                      <th className="no-border-bottom">
                        Total Project Cost (Rs.Cr)
                      </th>
                      <th className="no-border-bottom">
                        Implementation Agency
                      </th>
                      <th className="no-border-bottom">Physical Progress</th>
                    </tr>
                  </thead>
                  <tbody>
                    {tableData &&
                      tableData.length !== 0 &&
                      tableData[0].stateOrUT &&
                      tableData.map((row, index) => (
                        <tr>
                          <td>{index + 1}</td>
                          <td>{row.stateOrUT}</td>
                          <td>
                            <Form.Control
                              type="number"
                              className={`inputArea ${
                                errors[index] &&
                                errors[index].totalLocationsUncovered
                                  ? "my-error-field"
                                  : "noError"
                              }`}
                              onKeyDown={e => {
                                if (["e", "E", "+", "-"].includes(e.key)) {
                                  e.preventDefault();
                                }
                              }}
                              onChange={e => {
                                const value = e.target.value;
                                if (value.length > 10) return;
                                handleChange(
                                  index,
                                  "totalLocationsUncovered",
                                  value
                                );
                              }}
                              value={
                                row.totalLocationsUncovered !== undefined &&
                                row.totalLocationsUncovered !== null
                                  ? row.totalLocationsUncovered
                                  : totalLocationsUncovered || ""
                              }
                            />
                          </td>
                          <td>
                            <Form.Control
                              type="number"
                              className={`inputArea ${
                                errors[index] &&
                                errors[index].totalLocationsConnected
                                  ? "my-error-field"
                                  : "noError"
                              }`}
                              onKeyDown={e => {
                                if (["e", "E", "+", "-"].includes(e.key)) {
                                  e.preventDefault();
                                }
                              }}
                              onChange={e => {
                                const value = e.target.value;
                                if (value.length > 10) return;
                                handleChange(
                                  index,
                                  "totalLocationsConnected",
                                  value
                                );
                              }}
                              value={
                                row.totalLocationsConnected !== undefined &&
                                row.totalLocationsConnected !== null
                                  ? row.totalLocationsConnected
                                  : totalLocationsConnected || ""
                              }
                            />
                          </td>
                          <td>
                            <Form.Control
                              type="number"
                              className={`inputArea ${
                                errors[index] && errors[index].totalOFCPlanned
                                  ? "my-error-field"
                                  : "noError"
                              }`}
                              onKeyDown={e => {
                                if (["e", "E", "+", "-"].includes(e.key)) {
                                  e.preventDefault();
                                }
                              }}
                              onChange={e => {
                                const value = e.target.value;
                                if (value.length > 10) return;
                                handleChange(index, "totalOFCPlanned", value);
                              }}
                              value={
                                row.totalOFCPlanned !== undefined &&
                                row.totalOFCPlanned !== null
                                  ? row.totalOFCPlanned
                                  : totalOFCPlanned || ""
                              }
                            />
                          </td>
                          <td>
                            <Form.Control
                              type="number"
                              className={`inputArea ${
                                errors[index] && errors[index].totalOFCInstalled
                                  ? "my-error-field"
                                  : "noError"
                              }`}
                              onKeyDown={e => {
                                if (["e", "E", "+", "-"].includes(e.key)) {
                                  e.preventDefault();
                                }
                              }}
                              onChange={e => {
                                const value = e.target.value;
                                if (value.length > 10) return;
                                handleChange(index, "totalOFCInstalled", value);
                              }}
                              value={
                                row.totalOFCInstalled !== undefined &&
                                row.totalOFCInstalled !== null
                                  ? row.totalOFCInstalled
                                  : totalOFCInstalled || ""
                              }
                            />
                          </td>
                          <td>
                            <Form.Control
                              type="number"
                              className={`inputArea ${
                                errors[index] && errors[index].totalProjectCost
                                  ? "my-error-field"
                                  : "noError"
                              }`}
                              onChange={e => {
                                const value = e.target.value;
                                if (value.length > 10) return;
                                handleChange(index, "totalProjectCost", value);
                              }}
                              value={
                                row.totalProjectCost !== undefined &&
                                row.totalProjectCost !== null
                                  ? row.totalProjectCost
                                  : totalProjectCost || ""
                              }
                            />
                          </td>
                          <td>
                            <Form.Control
                              type="text"
                              className={`inputArea ${
                                errors[index] &&
                                errors[index].implementationAgency
                                  ? "my-error-field"
                                  : "noError "
                              }`}
                              onChange={e =>
                                handleChange(
                                  index,
                                  "implementationAgency",
                                  e.target.value
                                )
                              }
                              value={row.implementationAgency}
                            />
                          </td>
                          <td>
                            {row.physicalProgressPercentage !== "" &&
                            row.physicalProgressPercentage !== null &&
                            row.physicalProgressPercentage !== undefined &&
                            !Number.isNaN(
                              Number(row.physicalProgressPercentage)
                            )
                              ? row.physicalProgressPercentage + "%"
                              : "0%"}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </Table>
              </div>
            </div>
          </Modal.Body>
          <div class="iig-modal-footer">
            <Modal.Footer className="border-0 pt-0 pl-3">
              <div class="col">
                <div class="row iig-context-button-content justify-content-between align-items-center">
                  <div className="page-subline">
                    {/* <span className="iig-modal-content">
                      Do you want to take this action?
                    </span> */}
                  </div>
                  <div class="iig-modal-buttons d-flex">
                    <div class="iig-yes-button">
                      <Button
                        className="btn-orange-invert no-padding px-5"
                        onClick={onHide}
                      >
                        Cancel
                      </Button>
                    </div>
                    <div>
                      <Button
                        className="button-submit-cost no-padding px-5"
                        onClick={handleStateWiseData}
                      >
                        Submit
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </Modal.Footer>
          </div>
        </div>
      </Form>
    </Modal>
  );
};

// export default StateWiseCostModal;
export default withStyles(styles)(StateWiseCostModal);
